/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.7",
    versionName: "0.2.0-nightly.2026.5.7",
    versionChannel: "nightly",
    buildDate: "2026-05-07T00:31:02.695Z",
    commitHash: "8b22c4992362b9d8257db7c9f920e5bad31528e4",
};
